angular
  .module('app')
  .component('offers', {
    templateUrl: 'app/components/offers/Offers.html',
    controller: Offers
  });

/** @ngInject */
// eslint-disable-next-line
function Offers($rootScope, Params, PanelObserver, ConfigBookingEngine, Restangular, OffersManager, OffersParser, $timeout, $state, $translate) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.Params = Params;
  $this.PanelObserver = PanelObserver;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.Restangular = Restangular;
  $this.OffersParser = OffersParser;
  $this.OffersManager = OffersManager;
  $this.$timeout = $timeout;
  $this.$state = $state;
  $this.$translate = $translate;
  $this.isPanelEdited = false;
  $this.cart = [];
}

Offers.prototype = {
  $onInit: function () {
    this.userHash = this.Params.getUserHash();
    this.hotelId = this.Params.getHotelId();
    this.language = this.Params.getLanguage();
    this.categoryId = this.Params.getCategoryId();
    this.checkIn = this.Params.getCheckIn();
    this.checkOut = this.Params.getCheckOut();
    this.occupancy = this.Params.getOccupancy();
    this.discountCode = this.Params.getDiscountCode();
    this.roomGroupId = this.Params.getRoomGroupId();
    this.rateplanId = this.Params.getRateplanId();
    this.OffersManager.setRoomGroupId(this.roomGroupId);
    this.OffersManager.setRateplanId(this.rateplanId);
    var lengthOfStay = moment(this.checkOut).diff(this.checkIn, 'days');
    this.OffersManager.setLengthOfStay(lengthOfStay);
    var showOnlyAvailableRooms = !this.ConfigBookingEngine.showUnavailableOffers();
    this.OffersManager.setOnlyAvailableRooms(showOnlyAvailableRooms);
    var showOnlyAvailableRateplans = !this.ConfigBookingEngine.showUnavailableRateplans();
    this.OffersManager.setOnlyAvailableRateplans(showOnlyAvailableRateplans);
    var sortMethod = this.ConfigBookingEngine.getSortOffersMethod();
    this.OffersManager.setSortMethod(sortMethod);
    this.getOffers();
  },

  isEnabledHostelView: function () {
    return this.ConfigBookingEngine.isHostelViewEnabled();
  },

  getRoomsCount: function () {
    return this.occupancy.length;
  },

  getCartItemCount: function () {
    return this.cart.length;
  },

  getCurrentSelectedPersonsCount: function () {
    if (this.isEnabledHostelView()) {
      return 1;
    }
    return this.occupancy[this.getCartItemCount()].count;
  },

  getCurrentSelectedPersonsCat1Count: function () {
    if (this.isEnabledHostelView()) {
      return 0;
    }
    return this.occupancy[this.getCartItemCount()].cat1;
  },

  getCurrentSelectedPersonsCat2Count: function () {
    if (this.isEnabledHostelView()) {
      return 0;
    }
    return this.occupancy[this.getCartItemCount()].cat2;
  },

  getCurrentSelectedPersonsCat3Count: function () {
    if (this.isEnabledHostelView()) {
      return 0;
    }
    return this.occupancy[this.getCartItemCount()].cat3;
  },

  onPanelClick: function () {
    this.isPanelEdited = true;
  },

  cancelPanelEditing: function () {
    if (this.PanelObserver.isPanelChanged() === false) {
      this.isPanelEdited = false;
    }
  },

  showOffersList: function () {
    return this.isFullCart() === false || this.isEnabledHostelView();
  },

  showCart: function () {
    return this.getRoomsCount() > 1 || this.isEnabledHostelView();
  },

  addToCart: function (room, rateplan) {
    this.cart.push({
      room: room,
      rateplan: rateplan,
      persons: this.getCurrentSelectedPersonsCount(),
      personsCat1: this.getCurrentSelectedPersonsCat1Count(),
      personsCat2: this.getCurrentSelectedPersonsCat2Count(),
      personsCat3: this.getCurrentSelectedPersonsCat3Count()
    });
    if (this.getRoomsCount() === 1 && this.isEnabledHostelView() === false) {
      this.goToNextStep();
    } else if (this.isFullCart() === false || this.isEnabledHostelView()) {
      this.getOffers();
    }
  },

  removeFromCart: function () {
    this.cart.splice(0, 1);
    this.getOffers();
  },

  getOffersFromCart: function () {
    var result = [];
    for (var i = 0; i < this.cart.length; i++) {
      var cartItem = this.cart[i];
      result.push({
        roomId: cartItem.room.id,
        rateplanId: cartItem.rateplan.id,
        persons: cartItem.persons,
        personsCat1: cartItem.personsCat1,
        personsCat2: cartItem.personsCat2,
        personsCat3: cartItem.personsCat3
      });
    }
    return result;
  },

  goToNextStep: function () {
    var cartOffers = this.getOffersFromCart();
    this.$state.go('booking.guest', {
      checkIn: moment(this.checkIn).format('YYYY-MM-DD'),
      checkOut: moment(this.checkOut).format('YYYY-MM-DD'),
      occupancy: encodeURIComponent(angular.toJson(this.occupancy)),
      cart: encodeURIComponent(angular.toJson(cartOffers)),
      discountCode: this.discountCode
    });
  },

  isFullCart: function () {
    return this.getCartItemCount() >= this.getRoomsCount();
  },

  decreaseAvailableUnits: function (offers, roomId) {
    var offer = offers.filter(function (offer) {
      return offer.room.id === roomId;
    })[0];
    if (angular.isDefined(offer) && angular.isDefined(offer.room) && angular.isNumber(offer.room.availableUnits)) {
      offer.room.availableUnits--;
    }
  },

  subtractCartFromOffers: function (offers) {
    for (var i = 0; i < this.cart.length; i++) {
      var cartItem = this.cart[i];
      this.decreaseAvailableUnits(offers, cartItem.room.id);
    }
    return offers;
  },

  clearOffersList: function () {
    this.filteredOffersList = null;
  },

  getOffers: function () {
    var $this = this;
    $this.$rootScope.$emit('startLoading', {
      title: $this.$translate.instant('loader.PLEASE_WAIT'),
      description: $this.$translate.instant('loader.OFFERS')
    });
    /* eslint-disable camelcase */
    var requestParams = {
      start: moment($this.checkIn).format('YYYY-MM-DD'),
      end: moment($this.checkOut).subtract(1, 'day').format('YYYY-MM-DD'),
      hotel_id: this.hotelId,
      language: this.language,
      room_group_category_id: this.categoryId,
      persons_count: this.getCurrentSelectedPersonsCount(),
      age_category1: this.getCurrentSelectedPersonsCat1Count(),
      age_category2: this.getCurrentSelectedPersonsCat2Count(),
      age_category3: this.getCurrentSelectedPersonsCat3Count(),
      discount_code_name: this.discountCode
    };
    /* eslint-enable camelcase */
    $this.clearOffersList();
    var minPersons = $this.getCurrentSelectedPersonsCount() + $this.getCurrentSelectedPersonsCat2Count() + $this.getCurrentSelectedPersonsCat3Count();
    $this.OffersManager.setMinPersons(minPersons);
    $this.Restangular.all('offers/shortstay/' + this.userHash).getList(requestParams)
      .then(function (offersList) {
        $this.fullOffersList = $this.OffersParser.parse(offersList);
        var offers = $this.subtractCartFromOffers($this.fullOffersList);
        $this.filteredOffersList = $this.OffersManager.getAvailable(offers);
      })
      .catch(function (e) {
        $this.$state.go('booking.clientErrors', {}, {location: false});
      })
      .finally(function () {
        $this.$rootScope.$emit('stopLoading');
      });
  }
};
